export default "__VITE_ASSET__CWHeTXuB__"